import React, { useContext, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import StoreContext from '../../../react-core-lib/components/app/store-context';
import getStartedImg from '../../../assets/images/getStarted3Handouts2.png';
import getStartedMobileImg from '../../../assets/images/getStarted3HandoutsMobile.png';
import newHandoutImg from '../../../assets/images/newHandoutImg.png';
import skullImg from '../../../assets/images/Model3DCanineSkull.png';
import integrationImg from '../../../assets/images/Integration.png';
import startCustomisingImg from '../../../assets/images/StartCustomising.png';
import startCustomisingMobileImg from '../../../assets/images/StartCustomisingMobile.png';
import arrowRightIcon from '../../../assets/icons/ArrowRight.svg';
import playGreyIcon from '../../../assets/icons/PlayGrey.svg';
import CTAUpgradeDialog from '../../UIControls/CTAUpgradeDialog';
import { getCTAUpgradeImageUrl } from '../../../config';

function PanelButton({ label, onClick }) {
    const isClickable = typeof onClick === 'function';

    return (
        <Box
            onClick={isClickable ? onClick : undefined}
            sx={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '16.78px',
                background: '#FF669B',
                borderRadius: '223px',
                pl: { xs: '16px', md: '22px' },
                pr: { xs: '6px', md: '8px' },
                py: { xs: '6px', md: '8px' },
                cursor: isClickable ? 'pointer' : 'default',
                userSelect: 'none',
                ...(isClickable ? { '&:hover': { background: '#FF85B0' } } : {}),
            }}
        >
            <Typography
                sx={{
                    fontFamily: 'Inter, sans-serif',
                    fontWeight: 500,
                    fontSize: { xs: '14px', md: '18px' },
                    lineHeight: 'normal',
                    letterSpacing: { xs: '-0.28px', md: '-0.36px' },
                    color: '#FFFFFF',
                    whiteSpace: 'nowrap',
                }}
            >
                {label}
            </Typography>
            <Box
                component="img"
                src={arrowRightIcon}
                alt=""
                sx={{ width: { xs: 32, md: 40 }, height: { xs: 32, md: 40 }, display: 'block' }}
            />
        </Box>
    );
}

const TITLE_WHITE = {
    fontFamily: 'Inter, sans-serif',
    fontWeight: 600,
    fontSize: { xs: '24px', md: '40px' },
    lineHeight: { xs: '28px', md: '40px' },
    letterSpacing: { xs: '-0.6px', md: '-1.6px' },
    color: '#FFFFFF',
    position: 'absolute',
    top: { xs: '16px', md: '20px' },
    left: { xs: '16px', md: '20px' },
    zIndex: 2,
};

const TITLE_NAVY = {
    ...TITLE_WHITE,
    color: '#000453',
};

export function DashboardStartPanels() {
    const navigate = useNavigate();
    const { userDataStore } = useContext(StoreContext);
    const accountType = userDataStore?.subscriptionData?.accountType;
    const [upgradeCTAOpen, setUpgradeCTAOpen] = useState(false);
    const [upgradeCTAOpenProfessional, setUpgradeCTAOpenProfessional] = useState(false);

    const handle3DModelsClick = () => {
        if (accountType === 'Free' || accountType === 'Student') {
            (accountType === 'Free' ? setUpgradeCTAOpenProfessional : setUpgradeCTAOpen)(true);
            return;
        }
        // 3D Models are temporarily blocked in Physio.
        // navigate('/3d-models');
        navigate('/');
    };

    const handleTryCustomisationClick = () => {
        localStorage.setItem('openInCustomiseMode', 'true');
        navigate('/handout/17262b79-28cf-4b8c-a94e-f05516de054a');
    };

    const handleClinikoIntegrationClick = () => {
        navigate('/settings', { state: { scrollToSection: 'Integrations' } });
    };

    return (
        <>
            <Box
                sx={{
                    maxWidth: '1440px',
                    margin: '0 auto',
                    width: '100%',
                    px: { xs: '20px', md: '40px' },
                    pb: { xs: '16px', md: '21px' },
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: { xs: '16px', md: '21px' },
                }}
            >
                {/* Row 1: Get started (flex:2) + New handouts (flex:1) */}
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: { xs: '16px', md: '21px' },
                        height: { xs: 'auto', md: '408px' },
                    }}
                >
                    {/* Get Started panel */}
                    <Box
                        sx={{
                            flex: { xs: 'none', md: 2 },
                            height: { xs: '352px', md: '100%' },
                            borderRadius: { xs: '24px', md: '30px' },
                            background: 'linear-gradient(157deg, #FA96C3 2.66%, #FF669B 11.57%, #BD8DE8 91.74%)',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <Typography sx={TITLE_WHITE}>Get started</Typography>

                        <Box
                            component="picture"
                            sx={{
                                position: 'absolute',
                                top: { xs: '71px', md: '80px' },
                                left: { xs: 0, md: 'auto' },
                                right: { xs: 0, md: '124px' },
                                bottom: { xs: '31.56px', md: 0 },
                                height: { xs: 'calc(100% - 102.56px)', md: 'calc(100% - 80px)' },
                                width: { xs: '100%', md: 'auto' },
                                pointerEvents: 'none',
                                zIndex: 1,
                                display: 'block',
                            }}
                        >
                            <Box component="source" media="(max-width: 600px)" srcSet={getStartedMobileImg} />
                            <Box
                                component="img"
                                src={getStartedImg}
                                alt="Handouts preview"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: { xs: 'fill', md: 'contain' },
                                    objectPosition: 'bottom',
                                    display: 'block',
                                }}
                            />
                        </Box>

                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: { xs: '16px', md: '20px' },
                                left: { xs: '16px', md: '20px' },
                                zIndex: 2,
                            }}
                        >
                            <PanelButton label="Browse library" onClick={() => navigate('/search')} />
                        </Box>
                    </Box>

                    {/* New Handouts panel */}
                    <Box
                        sx={{
                            flex: { xs: 'none', md: 1 },
                            height: { xs: '352px', md: '100%' },
                            borderRadius: { xs: '24px', md: '30px' },
                            background: '#000453',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <Typography sx={TITLE_WHITE}>New handouts</Typography>

                        <Box
                            component="img"
                            src={newHandoutImg}
                            alt="New handout preview"
                            sx={{
                                position: 'absolute',
                                left: { xs: '32px', md: '74px' },
                                right: { xs: '32px', md: '74px' },
                                top: { xs: '80px', md: '94px' },
                                bottom: 0,
                                width: { xs: 'calc(100% - 64px)', md: 'calc(100% - 148px)' },
                                height: { xs: 'calc(100% - 80px)', md: 'calc(100% - 94px)' },
                                objectFit: 'contain',
                                objectPosition: 'bottom',
                                pointerEvents: 'none',
                                zIndex: 1,
                            }}
                        />

                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: { xs: '16px', md: '20px' },
                                left: { xs: '16px', md: '20px' },
                                zIndex: 2,
                            }}
                        >
                            <PanelButton label="View all" onClick={() => navigate('/new-handouts')} />
                        </Box>
                    </Box>
                </Box>

                {/* Row 2: 3D Models (flex:1) + Start customising (flex:2) */}

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: { xs: 'column', md: 'row' },
                        gap: { xs: '16px', md: '21px' },
                        height: { xs: 'auto', md: '408px' },
                    }}
                >
                    {/* Cliniko integration panel */}
                    <Box
                        sx={{
                            flex: { xs: 'none', md: 1 },
                            height: { xs: '352px', md: '100%' },
                            borderRadius: { xs: '24px', md: '30px' },
                            background: '#000453',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <Typography sx={TITLE_WHITE}>Cliniko Integration</Typography>

                        <Box
                            component="img"
                            src={integrationImg}
                            alt="Cliniko integration"
                            sx={{
                                position: 'absolute',
                                left: { xs: '9%', md: '40px' },
                                top: { xs: '31%', md: '124px' },
                                width: { xs: '82%', md: 'calc(100% - 80px)' },
                                height: 'auto',
                                pointerEvents: 'none',
                                zIndex: 1,
                            }}
                        />

                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: { xs: '16px', md: '20px' },
                                left: { xs: '16px', md: '20px' },
                                zIndex: 2,
                            }}
                        >
                            <PanelButton label="Get connected" onClick={handleClinikoIntegrationClick} />
                        </Box>
                    </Box>

                    {/* 3D Models panel temporarily hidden in Physio. Set display back to block/flex to re-enable. */}
                    <Box
                        sx={{
                            display: 'none',
                            flex: { xs: 'none', md: 1 },
                            height: { xs: '352px', md: '100%' },
                            borderRadius: { xs: '24px', md: '30px' },
                            background: '#000453',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <Typography sx={TITLE_WHITE}>3D Models</Typography>

                        {/* Skull image: top=93, left=67, right=66 */}
                        <Box
                            component="img"
                            src={skullImg}
                            alt="3D model preview"
                            sx={{
                                position: 'absolute',
                                left: { xs: '32px', md: '67px' },
                                right: { xs: '32px', md: '66px' },
                                top: { xs: '80px', md: '93px' },
                                bottom: 0,
                                width: { xs: 'calc(100% - 64px)', md: 'calc(100% - 133px)' },
                                height: { xs: 'calc(100% - 80px)', md: 'calc(100% - 93px)' },
                                objectFit: 'contain',
                                objectPosition: 'top center',
                                pointerEvents: 'none',
                                zIndex: 1,
                            }}
                        />

                        {/* Play button overlay — centred on image area */}
                        <Box
                            sx={{
                                position: 'absolute',
                                top: {
                                    xs: 'calc(80px + (100% - 80px) / 2)',
                                    md: 'calc(93px + (100% - 93px) / 2)',
                                },
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                zIndex: 2,
                                cursor: 'pointer',
                                '&:hover img': { opacity: 0.75 },
                            }}
                            onClick={handle3DModelsClick}
                        >
                            <Box
                                component="img"
                                src={playGreyIcon}
                                alt="Play"
                                sx={{ width: { xs: 64, md: 81 }, height: { xs: 64, md: 81 } }}
                            />
                        </Box>

                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: { xs: '16px', md: '20px' },
                                left: { xs: '16px', md: '20px' },
                                zIndex: 3,
                            }}
                        >
                            <PanelButton label="Explore models" onClick={handle3DModelsClick} />
                        </Box>
                    </Box>

                    {/* Start customising panel */}
                    <Box
                        sx={{
                            flex: { xs: 'none', md: 2 },
                            height: { xs: '352px', md: '100%' },
                            borderRadius: { xs: '24px', md: '30px' },
                            background: '#F0F0FC',
                            position: 'relative',
                            overflow: 'hidden',
                        }}
                    >
                        <Typography sx={TITLE_NAVY}>Start customising</Typography>

                        {/* StartCustomising image: top=92, left=237, right=237 (centered) */}
                        <Box
                            component="picture"
                            sx={{
                                position: 'absolute',
                                top: { xs: '73px', md: '92px' },
                                left: { xs: '33px', md: '237px' },
                                right: { xs: '33px', md: '237px' },
                                bottom: 0,
                                width: { xs: 'calc(100% - 66px)', md: 'calc(100% - 474px)' },
                                height: { xs: 'calc(100% - 73px)', md: 'calc(100% - 92px)' },
                                pointerEvents: 'none',
                                zIndex: 1,
                                display: 'block',
                            }}
                        >
                            <Box component="source" media="(max-width: 600px)" srcSet={startCustomisingMobileImg} />
                            <Box
                                component="img"
                                src={startCustomisingImg}
                                alt="Start customising preview"
                                sx={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'contain',
                                    objectPosition: 'center',
                                    display: 'block',
                                }}
                            />
                        </Box>

                        <Box
                            sx={{
                                position: 'absolute',
                                bottom: { xs: '16px', md: '20px' },
                                left: { xs: '16px', md: '20px' },
                                zIndex: 2,
                            }}
                        >
                            <PanelButton label="Try it out" onClick={handleTryCustomisationClick} />
                        </Box>
                    </Box>
                </Box>
            </Box>

            <CTAUpgradeDialog
                open={upgradeCTAOpen}
                handleClose={() => setUpgradeCTAOpen(false)}
                onConfirm={() => navigate('/settings/manage-subscription')}
                title="Get more from Cetra!"
                message="You've discovered a feature available on our paid plans. Upgrade to access all the tools you need to make Cetra part of your everyday workflow."
                buttonText="Upgrade plan"
                benefits={[
                    'Save, share and print unlimited handouts',
                    'Save and share customised & custom built handouts',
                    'Add up to 4 additional team members',
                    'Personalise with your clinic logo',
                    'Create bundles of handouts',
                    'Connect with supported PMS integrations',
                ]}
                footnote="… and more!"
                imageUrl={getCTAUpgradeImageUrl('clinic')}
            />

            <CTAUpgradeDialog
                open={upgradeCTAOpenProfessional}
                handleClose={() => setUpgradeCTAOpenProfessional(false)}
                onConfirm={() => navigate('/settings/manage-subscription')}
                title="Get more from Cetra!"
                message="You've discovered a feature available on our paid plans. Upgrade to access all the tools you need to make Cetra part of your everyday workflow."
                buttonText="Upgrade plan"
                benefits={[
                    'Save, share and print unlimited handouts',
                    'Save customised and custom built handouts',
                    'Personalise with your clinic details',
                    'Connect with supported PMS integrations',
                ]}
                footnote="… and more!"
                imageUrl={getCTAUpgradeImageUrl('professional')}
            />
        </>
    );
}

export default DashboardStartPanels;
